/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import {
  GdrpContainer, GdrpLink, GdrpText, GdrpTextWrapper, GdrpWrapper, GdrpButton, GdrpHeader,
} from './gdrpElements';

const index = () => {
  const [accepted, setAccepted] = useState(JSON.parse(localStorage.getItem('gdrp')) || false);

  const acceptGdrp = () => {
    setAccepted((prev) => !prev);
  };

  useEffect(() => {
    localStorage.setItem('gdrp', accepted);
  }, [accepted]);

  return (
    !accepted && (
    <GdrpContainer>
      <GdrpWrapper>
        <GdrpTextWrapper>
          <GdrpHeader>Cookie consent</GdrpHeader>
          <GdrpText>
            Please note that on our website we use cookies necessary for functioning of our website.
            To learn more about the cookies, how we use them and their benefits,
            {' '}
            <GdrpLink href="https://carboncollectiblenfts.com/cookies_policy" target="_blank" rel="noreferrer">please read our Cookies Policy.</GdrpLink>
            {' '}
            By clicking &quot;Accept&quot;, you agree to our
            use of cookies and similar technologies.
          </GdrpText>
        </GdrpTextWrapper>
        <GdrpButton onClick={acceptGdrp}>Accept</GdrpButton>
      </GdrpWrapper>
    </GdrpContainer>
    )
  );
};

export default index;
